"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOTIFICATION_RECIPIENT_AUDIENCE = void 0;
exports.getNotificationAudience = getNotificationAudience;
exports.isParticipantFacingNotification = isParticipantFacingNotification;
exports.isParticipantFacingTemplate = isParticipantFacingTemplate;
/**
 * Single source of truth mapping every notification `recipientType` to its audience.
 *
 * The `satisfies Record<NotificationRecipientType, NotificationAudience>` makes this exhaustive:
 * if a recipientType is added to (or removed from) the rosetta SDK enum, this object stops
 * compiling until the change is reflected here. This is the ONLY place the participant-vs-site
 * rule is defined — every other consumer derives its behaviour from it.
 */
exports.NOTIFICATION_RECIPIENT_AUDIENCE = {
    participant: 'participant',
    site_user: 'site',
    site_investigator: 'site',
    site_monitor: 'site',
    data_reviewer: 'site',
    principal_data_manager: 'site',
};
/** Resolves a recipientType to its audience; unknown/missing values are treated as site-facing. */
function getNotificationAudience(recipientType) {
    if (recipientType && recipientType in exports.NOTIFICATION_RECIPIENT_AUDIENCE) {
        return exports.NOTIFICATION_RECIPIENT_AUDIENCE[recipientType];
    }
    return 'site';
}
/** Whether a notification is participant-facing; only `participant` recipients are. */
function isParticipantFacingNotification(recipientType) {
    return getNotificationAudience(recipientType) === 'participant';
}
/**
 * Whether a custom notification template is participant-facing, given the study notification that
 * references it (`notification.templateResourceId === template id`).
 *
 * A template with no referencing notification (still in the Library / l10n map but not used by any
 * study notification) is treated as participant-facing: nothing proves it is site-only, so it must
 * not be silently excluded from participant translation or readiness. Referenced templates follow
 * `getNotificationAudience`, so unknown `recipientType` values stay site-facing.
 */
function isParticipantFacingTemplate(notification) {
    return notification ? isParticipantFacingNotification(notification.recipientType) : true;
}
//# sourceMappingURL=recipient_audience.js.map